// extracted by mini-css-extract-plugin
export default {"content":"Contact_content__6neNP","form":"Contact_form__cf591","button":"Contact_button__Z0DRZ"};